import { MutationKey } from '@tanstack/react-query';

import { CommonSuccess, GenericFailure } from '@playq/services-shared';
import { DeviceID } from '@playq/octopus2-devices';

import { services2 } from '/api/services2';
import { useEitherMutation, UseMutationOptionsExtended } from '/api/service-hooks';

export const deleteDevice: MutationKey = ['delete', 'device'];

export const useDeleteDevice = (
  options?: UseMutationOptionsExtended<CommonSuccess, GenericFailure | Error, { device: DeviceID }>
) =>
  useEitherMutation(({ device }) => services2.onlineDeviceService.deleteDevice(device), {
    mutationKey: deleteDevice,
    ...options,
  });
